import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { PRODUCTS, ProductInfo } from '../products.data';

@Component({
  selector: 'app-product',
  templateUrl: './product.component.html',
  styleUrls: ['./product.component.scss']
})
export class ProductComponent implements OnInit {
  products: ProductInfo[] = PRODUCTS;

  constructor(private router: Router) { }

  ngOnInit() {
  }

  openDetail(product: ProductInfo) {
    this.router.navigate(['/product', product.id]);
  }
}
